export default __webpack_public_path__ + "static/media/read-icon.58b320df.svg";